<template>
  <component :is="layoutComponent" :key="layout" />
</template>

<script setup>
// #region 引用
import { useBaseInfoStore } from '@/stores/base-info';
import { useHeartbeat } from '@/hooks/useHeartbeat';
// #endregion

// #region props/emit

// #endregion

// #region 变量/常量
const useBaseInfo = useBaseInfoStore();
const layoutAdmin = defineAsyncComponent(
  () => import('@/layouts/admin/AdminLayout.vue'),
);
const layoutEmpty = defineAsyncComponent(
  () => import('@/layouts/empty/EmptyLayout.vue'),
);
const layoutFront = defineAsyncComponent(
  () => import('@/layouts/front/FrontLayout.vue'),
);
const layoutMobile = defineAsyncComponent(
  () => import('@/layouts/mobile/MobileLayout.vue'),
);

const route = useRoute();
const layout = ref(null);
const watched = ref(false);
const layoutComponent = computed(() => {
  switch (layout.value) {
    case 'admin':
      return layoutAdmin;
    case 'front':
      return layoutFront;
    case 'mobile':
      return layoutMobile;
    default:
      return watched.value ? layoutEmpty : null;
  }
});

// #endregion

// #region 业务方法
watch(
  () => route.meta,
  (to) => {
    layout.value = to.layout;
    // 存储layout
    useBaseInfo.setVueLayout(to.layout);
    watched.value = true;
  },
);

// #endregion

// #region 生命周期

// 心跳：登录后每分钟一次，登出自动停
useHeartbeat();

// #endregion
</script>

<style>
@import url('@/styles/index.css');

/* .auth-message-box:not(.el-overlay) {
} */
.el-overlay-message-box:has(.auth-message-box) {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100vw;
  height: 100vh;
}

.flow-drawer-modal {
  background-color: unset !important;
}
</style>
